// this file is generated by update_shopify_store_data.py at 2026-11-03 20:12:31.174321
var courses = [
    {
        "course_id": "8B2FF1C4-B542-EF11-998E-005056A7F31D",
        "course_version": 1,
        "name": "ANA: APRN Pharmacology Today: Pharmacotherapy of Diabetes Mellitus",
        "course_type": 1,
        "author_information": "",
        "description": "Overview: \r\nThis course explores the latest advancements in drug therapies for treating diabetes mellitus. It outlines the pharmacotherapeutic principles of the various modalities, with comparative analysis of efficacy and adverse effects and attention to special patient populations. In reviewing the evidence-based guidance and case studies, you will gain comprehensive insight into tailoring pharmacologic approaches to each patient to optimize treatment given the unique challenges presented by diabetes mellitus.",
        "learning_objectives_html": "At the conclusion, participants should be able to:\r\n<ul>Apply the latest evidence and guideline recommendations on diabetes mellitus to the pharmacologic treatment of individual's diagnosed with this disorder.\r\n    <br />\r\n    Compare and contrast the pharmacologic treatments for diabetes mellitus, considering pharmacokinetics, pharmacodynamics, and pharmacotherapeutics.\r\n    <br />\r\n    Formulate treatment and monitoring plans, integrating effective pharmacologic interventions for individuals exhibiting symptoms of diabetes mellitus.\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D089F81-80D3-EF11-9991-005056A78EAA",
                "course_category_name": "ANA - ANA APRN Pharmacology Bundle - Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pharmacology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Anesthetist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];